import { Head, Link, useForm } from '@inertiajs/react'
import { AuthShell, type ValuePanel } from '@/components/auth/AuthShell'
import { Button } from '@/components/ui/Button'
import { Field } from '@/components/ui/Field'

type Labels = {
  title: string
  password: string
  password_confirmation: string
  submit: string
  back_link: string
}

type Props = {
  token: string
  labels: Labels
  value_panel: ValuePanel
}

export default function PasswordEdit({ token, labels, value_panel }: Props) {
  const { data, setData, put, processing, errors } = useForm({
    password: '',
    password_confirmation: '',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    put(`/passwords/${token}`)
  }

  return (
    <>
      <Head title={labels.title} />
      <AuthShell valuePanel={value_panel}>
        <h1 className="font-display text-3xl text-ink">{labels.title}</h1>

        <form onSubmit={handleSubmit} className="mt-6 space-y-5">
          <Field
            label={labels.password}
            name="password"
            type="password"
            value={data.password}
            onChange={(e) => setData('password', e.target.value)}
            required
            autoFocus
            error={errors.password}
          />
          <Field
            label={labels.password_confirmation}
            name="password_confirmation"
            type="password"
            value={data.password_confirmation}
            onChange={(e) => setData('password_confirmation', e.target.value)}
            required
            error={errors.password_confirmation}
          />
          <Button type="submit" disabled={processing} className="w-full disabled:opacity-60">
            {labels.submit}
          </Button>
        </form>

        <Link href="/session/new" className="mt-6 inline-block text-sm font-semibold text-ink-soft hover:text-ink">
          {labels.back_link}
        </Link>
      </AuthShell>
    </>
  )
}
